import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { VirtualOfficeCard } from './VirtualOfficeCard';
import { globalPlans } from '../../../helpers/helperFunctions';

const Box = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    max-width: 350px;
  }
  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }
`;

interface VirtualOfficeGridProps {
  setSelected: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setStep: Dispatch<SetStateAction<number>>;
}

export const VirtualOfficeGrid = ({
  setSelected,
  setIsOpen,
  setStep
}: VirtualOfficeGridProps) => {
  return (
    <Box>
      {globalPlans().map((plan, i) => (
        <VirtualOfficeCard
          key={i}
          plan={plan}
          setSelected={setSelected}
          setIsOpen={setIsOpen}
          setStep={setStep}
        />
      ))}
    </Box>
  );
};
